const cookie: any = {
  getRootDomain: function() {
    let d: any = document.domain
    if (d.indexOf(".") > 0 && !d.isIP()) {
      let arr = d.split(".")
      let len = arr.length
      let d1 = arr[len - 1]
      let d2 = arr[len - 2]
      let d3 = arr[len - 3]
      d =
        d2 === "com" || d2 === "net" ? d3 + "." + d2 + "." + d1 : d2 + "." + d1
    }
    return d
  },
  load: function() {
    let tC = document.cookie.split("; ")
    let tO: any = {}
    let a = null
    for (let i = 0; i < tC.length; i++) {
      a = tC[i].split("=")
      tO[a[0]] = a[1]
    }
    return tO
  },
  get: function(name: string) {
    let value = this.load()[name]
    if (value) {
      try {
        return decodeURI(value)
      } catch (e) {
        return unescape(value)
      }
    } else {
      return false
    }
  },
  set: function(name: string, value: string, options: any) {
    options =
      typeof options === "object"
        ? options
        : {
            minute: options
          }
    let argLen = arguments.length
    let path = argLen > 3 ? arguments[3] : options.path || "/"
    let domain =
      argLen > 4
        ? arguments[4]
        : options.domain || (options.root ? this.getRootDomain() : "")
    let exptime = 0
    if (options.day) {
      exptime = 1000 * 60 * 60 * 24 * options.day
    } else if (options.hour) {
      exptime = 1000 * 60 * 60 * options.hour
    } else if (options.minute) {
      exptime = 1000 * 60 * options.minute
    } else if (options.second) {
      exptime = 1000 * options.second
    }
    let exp: any = new Date()
    let expires = ""
    if (exptime > 0) {
      exp.setTime(exp.getTime() + exptime)
      expires = "; expires=" + exp.toGMTString()
    }
    domain = domain ? "; domain=" + domain : ""
    document.cookie =
      name + "=" + escape(value || "") + "; path=" + path + domain + expires
  },
  del: function(name: string, options: any) {
    options = options || {}
    let path = "; path=" + (options.path || "/")
    let domain = options.domain ? "; domain=" + options.domain : ""
    if (options.root) domain = "; domain=" + this.getRootDomain()
    document.cookie =
      name + "=" + path + domain + "; expires=Thu,01-Jan-70 00:00:01 GMT"
  }
}

export default cookie
